export const WARNING_EMPTY_ADD_CATEOGRY_FIELDS = 'Some fields are empty.';
export const WARNING_CATEGORY_EXISTS = 'A category with this name already exists.';
